const VALID_SEARCH_TYPES = ['region', 'postcode', 'place'] as const;

export type ValidSearchType = (typeof VALID_SEARCH_TYPES)[number];

export const validateSearchTypes = (type: string): type is ValidSearchType =>
  (VALID_SEARCH_TYPES as readonly string[]).includes(type);

export default validateSearchTypes;
